import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ChangeDetectionStrategy
} from '@angular/core';
import { DepartmentAudit } from '../../+models/company-profile-audit.model';

@Component({
  selector: 'sd-portal-department-audit-list',
  templateUrl: './department-audit-list.component.html',
  styleUrls: ['./department-audit-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DepartmentAuditListComponent implements OnInit {
  @Input() departmentId: number;
  @Input() loading: boolean;
  @Input() departmentAudits: DepartmentAudit[];

  @Output() loadDepartment = new EventEmitter<number>();
  @Output() nextPage = new EventEmitter<number>();

  constructor() {}

  ngOnInit() {}

  loadData() {
    this.loadDepartment.emit(this.departmentId);
  }

  onNextPage() {
    this.nextPage.emit(this.departmentId);
  }
}
